import { render, staticRenderFns } from "./MainLedgerReports.vue?vue&type=template&id=67606671&scoped=true"
import script from "./MainLedgerReports.vue?vue&type=script&lang=js"
export * from "./MainLedgerReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67606671",
  null
  
)

export default component.exports